import React, {useState} from 'react'
import {Button, Form, Header, Checkbox} from 'semantic-ui-react'
import Dialog from '../../dialog'
import useSWR  from 'swr'
import * as Yup from 'yup'
import {GlossaryFetcher, GlossarySave} from '../../../fetch/glossary'
import {getApiResponseErrorMessage} from '../../error'
import {fieldNames, statusOptions, creationTypes} from "../options"
import classNames from 'classnames'
import {AppFetcher} from "../../../fetch/application"
import {allElements, marginB10, marginB4, panelBox} from "../../glossary/sidebar.module.scss"

const AppDataCreation = ({ id, open, loading, onSubmit, onClose, content, data }) => {

    const initialState = {
        loading: false,
        description: '',
        type: '',
        status: '',
        docLink: '',
        applicationId: id,
        dataContentId: content.id,
        dataCreationContributions: null
    }
    const [state, setState] = useState(initialState)
    const loadElements = React.useRef(true);

    const { data: details, errorDetails } = useSWR(!data ? null : `/data-creation/details/${data.id}`, AppFetcher, {errorRetryCount: 2})
    React.useEffect(() => {
        if(details ) {
            setState({
                ...state,
                id: details.data.id,
                description: details.data.description,
                status: details.data.status,
                type: details.data.type,
                docLink: details.data.docLink,
                dataCreationContributions: details.data.dataCreationContributions.map(i => i.contributionDataContentId)
            })
        }
    }, [details, data])

    const [dataContents, setDataContents] = useState(null)
    const { data: list, errorList } = useSWR(`/data-content/list/${id}`, AppFetcher, {errorRetryCount: 2})
    React.useEffect(() => {
        if(data && details && list && list.data) {
            let tmp_list = [];
            list.data.map(object => {
                let tmp_checked = false;
                if (details.data.dataCreationContributions) {
                    details.data.dataCreationContributions.map(i => {
                        if (i.contributionDataContentId === object.id) {
                            tmp_checked = true
                        }
                    })
                }

                (object.id !== content.id) && tmp_list.push({
                    value: object.id,
                    text: object.name,
                    checked: tmp_checked
                })
            })

            setDataContents(tmp_list)
        }
        else if(!data && list && list.data) {
            let tmp_list = [];
            list.data.map(object => {
                (object.id !== content.id) && tmp_list.push({
                    value: object.id,
                    text: object.name,
                    checked: false
                })
            })

            setDataContents(tmp_list)
        }
    }, [list, details, data])

    const [errors, setError] = useState({})

    const formSchema = Yup.object().shape({
        description: Yup.string().required(),
        status: Yup.string().required(),
        type: Yup.string().required(),
    });

    const handleInputChange = (e, {name, value}) => {

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const addContent = (e, data) => {
        let _tmpC = dataContents;
        _tmpC.map((i) => {
            if(i.value === data.value) {
                i.checked = data.checked
            }
            return i;
        })
        setDataContents(_tmpC);
        let _tmpC2 = _tmpC.filter(i=> i.checked).map(j => j.value);
        setState(state => {
            return {
                ...state,
                dataCreationContributions: _tmpC2
            }
        })
    }

    const handleOnSubmit = () => {

        setError({})

        formSchema.validate(state, {abortEarly: false}).then( data => {

            if (typeof onSubmit === 'function') {
                const reply = GlossarySave(`/data-creation/save`, data)

                reply.then(res => {
                    if (res.success === true) {
                        onSubmit()
                        setState(state => initialState);
                    }
                }).catch( error => {
                    const errorFields = {}

                    for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })
                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false,
                        }
                    })
                })
            }

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setState(initialState);
        onClose()
    }

    if(loadElements.current === false) {
        loadElements.current = true;
    }

    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>
            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {data && data.id ? "Edit Data Creation" : "Add new Data Creation"} {content && content.name ? "for " + content.name : ""}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Input
                                name="description"
                                error={errors.description}
                                label="Creation description"
                                value={ state.description}
                                onChange={handleInputChange}
                            />

                            <br />

                            <Form.Input
                                name="docLink"
                                label="Document Link"
                                error={errors.docLink}
                                value={ state.docLink}
                                onChange={handleInputChange}
                            />

                            <br />

                            <Form.Select
                                name="type"
                                label="Creation Type"
                                error={errors.type}
                                placeholder={"Select Type"}
                                options={creationTypes}
                                value={ state.type}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />

                            <Form.Select
                                name="status"
                                label="Status"
                                error={errors.status}
                                placeholder={"Select Status"}
                                options={statusOptions}
                                value={state.status}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />
                            <div style={{marginTop: "16px"}}> </div>
                            {dataContents &&
                            <div className={classNames(panelBox)}>
                                <Header as="h5" className={marginB4}>Add Data Contributions (optional)</Header>
                                <div style={{height: "20px"}}> </div>
                                {dataContents && dataContents.length > 0 &&
                                <>
                                    <div className={allElements}>
                                        {dataContents.map((i, index) => {
                                            return <div  className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {i.checked}
                                                    label={i.text}
                                                    value={i.value}
                                                    onClick={addContent} />
                                            </div>
                                        })}
                                    </div>
                                </>}
                            </div>}

                        </Form.Field>

                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default AppDataCreation